export default "__VITE_ASSET__DugwMmsJ__"